import classNames from "lib/classNames";
import React, { useContext, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import ShopContext from "context/ShopContext";
import Lottie from "react-lottie";
import animationData from "lib/rocket-animation.json";
import { UPDATE_SHOP_PROP } from "lib/mutations";
import { Button, Dropdown, Icon } from "components";
import { Redirect } from "@shopify/app-bridge/actions";
import EmbeddedContext from "context/EmbeddedContext";

export default function ({ setItem }) {
    const [themes, setThemes] = useState([]);
    const { state } = useContext(ShopContext);
    const { static_file_status, static_file_mode } = state;
    const isProcessing = static_file_status === "processing"
    const isCompleted = static_file_status === "completed"
    const [loading, setLoading] = useState(false);
    const activateStaticGenerator = async ({ disable = false } = {}) => {
        try {
            setLoading(disable ? "disable" : "activate");
            const { status, mode: response_mode } = await API.post(
                "API_GATEWAY_NEW",
                "/static_generator/activate",
                { body: { disable } }
            );
            setItem("static_file_status", status)
            setItem("static_file_mode", response_mode)
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };
    return (
        <div
            id="StaticFileIntegration"
            className={classNames(
                "hidden flex items-center bg-blue-100 rounded shadow my-5 p-3"
            )}
        >
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice"
                    }
                }}
                height={180}
                width={180}
            />
            <div className={classNames("flex-1 pl-3")}>
                <h4 className={classNames("text-xl font-bold text-gray-700 mb-3")}>
                    Congratulations, you are eligible for the ⚡Lightning speed
                    integration
                </h4>
                <p className={classNames("leading-loose")}>
                    The Lightning Speed Integration is 10x faster than the current
                    integration, Start by selecting the test mode and click activate.
                </p>
                <a href="#" className={classNames("font-bold underline text-gray-700 text-sm")}>Learn more about this integration</a>
                <div className={classNames("flex justify-end mt-3")}>
                    {isProcessing && <div className={classNames("text-gray-600 text-sm")}>
                        <Icon spin={true} size="sm" icon="spinner-third" className="mr-2" /> Processing
                    </div>}
                    {!isProcessing && !isCompleted && <ActivateButton  {...{ activateStaticGenerator, loading }} />}
                    {!isProcessing && isCompleted && <ActivateButton {...{ activateStaticGenerator, loading, disable: true }} />}
                </div>
            </div>
        </div>
    );
}

function ActivateButton ({ loading, activateStaticGenerator, disable = false }) {
    const action = disable ? "disable" : "activate"
    const text = action.charAt(0).toUpperCase() + action.slice(1)
    return <Button
        text={text}
        onClick={() => activateStaticGenerator({ disable })}
        loading={loading === action}
        type={disable ? "danger" : "primary"}
    />

}